module.exports = __webpack_public_path__ + "img/iconProvince4.c2deb973.svg";